import { atomWithStorage } from 'jotai/utils';
export const chatUiStyleAtom = atomWithStorage('wa_chat_ui_style', 'default');
export const chatBackgroundUrlAtom = atomWithStorage('wa_chat_bg_url', '');
export const chatPreferencesAtom = atomWithStorage('wa_chat_prefs', {
    readReceipts: true,
    vibrate: true,
});
export const chatNicknameAtom = atomWithStorage('wa_chat_nickname', 'user');
export const chatStatusAtom = atomWithStorage('wa_chat_status', '在线');
export const chatAvatarDataUrlAtom = atomWithStorage('wa_chat_avatar', undefined);
export const chatModelUrlAtom = atomWithStorage('wa_model_url', 'http://localhost:11434/v1');
export const chatModelNameAtom = atomWithStorage('wa_model_name', 'qwen3-7b');
export const chatModelApiKeyAtom = atomWithStorage('wa_model_api_key', '');
export const waPersonasAtom = atomWithStorage('wa_personas', []);
export const waMessagesMapAtom = atomWithStorage('wa_messages_map', {});
export const waCurrentPersonaIdAtom = atomWithStorage('wa_current_persona_id', null);
export const waInitDoneAtom = atomWithStorage('wa_init_done', false);
// 自我人设（优先作为 globals.user/user_title 的来源）
export const waSelfNicknameAtom = atomWithStorage('wa_self_nickname', 'user');
export const waSelfDefineAtom = atomWithStorage('wa_self_define', '');
// 角色记忆（追加到我的人设后，通过 globals.persona_description 传给服务端）
export const waSelfMemoryAtom = atomWithStorage('wa_self_memory', '');
// 最多回复条数（服务端限制生成条数），默认 7
export const waMaxMsgCntAtom = atomWithStorage('wa_max_msg_cnt', 7);
// 每个会话（人设）独立壁纸
export const waWallpaperMapAtom = atomWithStorage('wa_wallpaper_map', {});
export const waFeedsAtom = atomWithStorage('wa_feeds', []);
